import { Card, CardProps } from 'antd';
import clx from 'classnames';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

export const StyledResponsiveCard = styled(Card)`
  .ant-card-body {
    ${down('sm')} {
      padding: 12px;
    }
  }
  &.no-padding {
    > .ant-card-body {
      padding: 0;
      ${down('sm')} {
        padding: 0;
      }
    }
  }
`;

export interface ResponsiveCardProps extends CardProps {
  noPadding?: boolean;
}

/**
 * Card Responsive
 * riduce il padding del body dalla Card (da 24px a 12px)
 * se impostato noPadding rimuove Sempre il padding del body
 *
 * @param noPadding Rimuove Sempre il padding del body della Card
 */
export function ResponsiveCard(props: ResponsiveCardProps) {
  const { noPadding, className, ...cardProps } = props;
  return (
    <StyledResponsiveCard
      bordered={false}
      {...cardProps}
      className={clx(className, 'responsive-card', {
        'no-padding': noPadding,
        'has-padding': !noPadding,
      })}
    />
  );
}
